type PillColor = "slate" | "blue" | "green" | "amber" | "violet" | "rose";

type StatPill = {
  label: string;
  value: string | number | null | undefined;
  suffix?: string;
  color?: PillColor;
  title?: string;
};

type StatPillsProps = {
  items?: StatPill[];
};

export default function StatPills({ items = [] }: StatPillsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {items.map(({ label, value, suffix = "g", color = "slate", title }, i) => {
        const map: Record<PillColor, string> = {
          slate: "bg-slate-100 text-slate-700",
          blue: "bg-blue-100 text-blue-700",
          green: "bg-green-100 text-green-700",
          amber: "bg-amber-100 text-amber-700",
          violet: "bg-violet-100 text-violet-700",
          rose: "bg-rose-100 text-rose-700",
        };

        return (
          <div
            key={i}
            className={`px-2.5 py-1 rounded-full text-xs font-medium ${
              map[color] || map.slate
            }`}
            title={title || ""}
          >
            <span className="opacity-70">{label}:</span>{" "}
            <span className="font-semibold">{value ?? "-"}</span>
            {suffix ? <span className="opacity-70"> {suffix}</span> : null}
          </div>
        );
      })}
    </div>
  );
}
